<template>
<div>
  <v-layout row wrap justify-center>
    <v-flex class="px-2 pb-2" xs12>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap justify-center>
        <v-flex class="px-2 pb-2" xs12 md7>
          <v-text-field
            label="Section Name"
            v-model.trim="newName"
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs12 md10>
          <v-text-field
            label="Instructions"
            v-model.trim="newSection.instructions"
            rows="3"
            hide-details
            textarea
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-4 text-xs-center" xs12>
          <v-btn
            @click.native="canSave"
            class="my-0"
            color="success"
            :loading="updating"
            :disabled="updating"
            large
          >Save</v-btn>
          <v-btn @click.native="popup.type = 'Resetting', popup.show = true" class="my-0" color="error" large flat>
            <b>Reset</b>
          </v-btn>
        </v-flex>
        <v-flex class="px-2 py-4" xs12 md10>
          <v-divider></v-divider>
        </v-flex>
        <v-flex class="px-2 pb-4 text-xs-center" xs12 md10>
          <v-btn @click.native="setupDeleteSection()" color="error" :disabled="deleting" :loading="deleting" large>Delete Section</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>

  <r-content-popup
    :popup="popup"
    :section-data="newSection"
    :deleting-data="toDelete"
  ></r-content-popup>
</div>
</template>

<script>
import {contentEvent} from '../../main'
import ContentPopup from './ContentPopup.vue'
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rContentPopup: ContentPopup,
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    updating: false,
    deleting: false,
    toDelete: {},
    sections: [],
    sectionData: {},
    newSection: {},
    newName: '',
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    contentEvent.$off()
    this.load()
    contentEvent.$on('reset', () => {
      this.resetNewSection()
    })
    contentEvent.$on('updateSection', () => {
      this.updateSection()
    })
    contentEvent.$on('delete', () => {
      this.deleteSection()
    })
  },
  methods: {
    load () {
      this.loading = true
      const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      this.sections = this.$store.getters.sectionByContent(contentData.key)
      for (let s of this.sections) {
        if (s.url === this.$route.params.sectionUrl) this.sectionData = s
      }
      this.resetNewSection()
      this.loading = false
    },
    resetNewSection () {
      this.newSection = {...this.sectionData}
      this.newName = this.newSection.name
      this.popup.show = false
    },
    changed () {
      if (typeof this.sectionData === 'undefined' || typeof this.newSection === 'undefined') return true
      let name = this.sectionData.name.toLowerCase() !== this.newName.toLowerCase()
      let instructions = this.sectionData.instructions.toLowerCase() !== this.newSection.instructions.toLowerCase()
      return name || instructions
    },
    canSave () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.changed()) {
        if (this.newName === '') {
          appMsg.msg = 'Please enter a name for the section'
          this.$store.dispatch('showAppMsg', appMsg)
          return false
        }
        if (this.newName.toLowerCase() === 'create') {
          appMsg.msg = 'Please use a different name; that name is reserved.'
          this.$store.dispatch('showAppMsg', appMsg)
          return false
        }
        if (this.newSection.instructions === '') {
          appMsg.msg = 'Please enter a instructions for the section'
          this.$store.dispatch('showAppMsg', appMsg)
          return false
        }
        if (this.sectionData.name.toLowerCase() !== this.newName.toLowerCase()) {
          for (let s of this.sections) {
            if (this.newName.toLowerCase() === s.name.toLowerCase()) {
              appMsg.msg = 'That section name already exists'
              this.$store.dispatch('showAppMsg', appMsg)
              return false
            }
          }
        }
        this.popup = {
          show: true,
          type: 'Updating Section'
        }
      } else {
        appMsg.msg = 'No change detected'
        this.$store.dispatch('showAppMsg', appMsg)
      }
    },
    updateSection () {
      this.updating = true
      let nameChanged = !(this.newSection.name === this.newName)
      const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      this.newSection.name = this.newName
      this.newSection.url = this.$store.getters.formatUrl(this.newSection.name)
      this.newSection.contentKey = contentData.key
      this.$store.dispatch('updateSection', this.newSection).then(() => {
        const appMsg = {
          type: 'success',
          msg: this.sectionData.name + ' updated!'
        }
        this.updating = false
        this.$store.dispatch('showAppMsg', appMsg)
        if (nameChanged) this.$router.push('/content')
        else this.load()
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.updating = false
        this.$store.dispatch('showAppMsg', appMsg)
      })
    },
    setupDeleteSection () {
      this.toDelete = {...this.sectionData}
      this.popup = {
        show: true,
        type: 'Deleting Section'
      }
    },
    deleteSection () {
      this.deleting = true
      const sectionName = this.toDelete.name
      this.$store.dispatch('deleteSection', this.toDelete).then(() => {
        const appMsg = {
          type: 'success',
          msg: sectionName + ' has been deleted'
        }
        this.deleting = false
        this.$router.push('/content')
        this.$store.dispatch('showAppMsg', appMsg)
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.deleting = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/EditSection.vue